import { Col } from 'antd';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';
import { useNotifications } from '../../../hooks/useNotifications';

const useModalFieldsVerification = () => {
  const { showModalVerifyFields } = useNotifications();
  const { translate: t } = useDictionaryTranslation();

  const verifyFields = (fields) => {
    if (fields.length < 0) return;
    showModalVerifyFields({
      title: 'unfilledFields',
      content: (
        <>
          <p>{t('unfilledText')}</p>
          {fields.map((field, index) => (
            <Col key={index} md={24} xs={24}>
              • {t(field.name[0])}
            </Col>
          ))}
        </>
      ),
      onOk: () => {},
    });
  };

  return { verifyFields };
};

export default useModalFieldsVerification;
